import { css, html } from 'react-strict-dom';
import { MaybeLink, Text, TimerButton, TimerCompanyLogo } from 'src/components';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { useTimer, useTimerElapsed } from 'src/contexts';
import { formatElapsed } from 'src/util';

/**
 * The clock still running, sitting at the top of today as the newest thing on
 * the timesheet.  It has no menu: the minutes are not settled, so there is
 * nothing to correct until it is stopped.
 */
export default function TimeLogRunningRow() {
  const { runningTarget } = useTimer();
  const elapsedSeconds = useTimerElapsed();

  if (!runningTarget) return null;

  return (
    <html.div style={[Style.row, Style.alignCenter, styles.row]}>
      <html.span style={styles.dot} />

      <TimerCompanyLogo
        company={runningTarget.company}
        title={runningTarget.title}
      />

      <html.div style={[Style.col, styles.label]}>
        <html.div style={[Style.row, Style.alignCenter, styles.nameRow]}>
          <MaybeLink to={runningTarget.path}>
            <Text typeface="body.small.medium" color="neutral100">
              {runningTarget.title}
            </Text>
          </MaybeLink>
          {runningTarget.reference && (
            <Text typeface="caption.medium" color="neutral60">
              {runningTarget.reference}
            </Text>
          )}
        </html.div>
        <Text typeface="caption.medium" color="green">
          {runningTarget.company
            ? `${runningTarget.company.name} · running now`
            : 'Running now'}
        </Text>
      </html.div>

      <html.span style={styles.elapsed}>
        <Text typeface="body.small.medium" color="green" textAlign="right">
          {formatElapsed(elapsedSeconds)}
        </Text>
      </html.span>

      <TimerButton target={runningTarget} size="small" tone="subtle" />
    </html.div>
  );
}

const styles = css.create({
  row: {
    gap: 12,
    paddingBlock: 10,
    paddingLeft: 16,
    paddingRight: 12,
    backgroundColor: color.greenBg,
  },
  dot: {
    flexShrink: 0,
    width: 8,
    height: 8,
    borderRadius: 999,
    backgroundColor: color.green,
  },
  label: {
    flexGrow: 1,
    minWidth: 0,
    gap: 2,
  },
  nameRow: {
    gap: 6,
    minWidth: 0,
  },
  elapsed: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    fontVariantNumeric: 'tabular-nums',
  },
});
